import React, { useCallback, useEffect } from "react"
import { FaDeleteLeft } from "react-icons/fa6"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./ApprovePaymentModalKeypad.module.scss"

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "پاک", "0", "del"]

const ApprovePaymentModalKeypad = props => {
  const { value, disabled, onChange } = props

  const i18n = useTranslation()[1]

  const handlePress = (key) => {
    if (key === "پاک") return onChange("0")

    const string = value === 0 ? "" : String(value)

    if (value === "0" && key === "0") {
      return onChange(Number(value))
    }

    if (key === "del") {
      const newValue =
        Number(
          string.length === 1 || string.length === 0 ? 0 :
            string.substring(0, string.length - 1)
        )

      return onChange(newValue)
    }

    onChange(Number(string + key))
  }

  const handleKeyPress =
    useCallback((e) => {
      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === "Delete") {
        key = "پاک"
      }

      if (key === "") return

      handlePress(key)
    }, [value])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [value])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["container"],
        isLtr && classes["container-ltr"]
      )}
    >
      {keys.map(key =>
        <button
          key={key}
          disabled={disabled}
          className={classes["key"]}
          onClick={() => handlePress(key)}
        >
          {key === "del" ?
            <FaDeleteLeft size={15} /> : key
          }
        </button>
      )}
    </div>
  )
}

export default React.memo(ApprovePaymentModalKeypad)